import { useContext, useEffect } from 'react'
import { ApplicationContext } from '../context/application'
import { useRouter } from 'next/router'
import { useGetApplicationHouseholdMembersLazyQuery } from '../../types/graphql'

export const useHouseholdMembers = function useHouseholdMembers() {
    const applicationContext = useContext(ApplicationContext)
    const router = useRouter()
    const [
        getHouseholdMembers,
        { data, loading, error, refetch, called },
    ] = useGetApplicationHouseholdMembersLazyQuery()

    useEffect(() => {
        const applicationId = router.query.applicationId?.toString()
        if (applicationId) {
            void getHouseholdMembers({ variables: { applicationId: applicationId } })
        }
    }, [router])

    useEffect(() => {
        if (data) {
            applicationContext.setHouseholdMembers(data.personApplication.householdMembers)
        }
    }, [data])

    return {
        loading,
        error,
        refetch,
        called,
    }
}
